/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealreview_Teaser2Inputs */

const en_coinvestments_dealreview_teaser2 = /** @type {(inputs: Coinvestments_Dealreview_Teaser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaser`)
};

/**
* | output |
* | --- |
* | "Teaser" |
*
* @param {Coinvestments_Dealreview_Teaser2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealreview_teaser2 = /** @type {((inputs?: Coinvestments_Dealreview_Teaser2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealreview_Teaser2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealreview_teaser2(inputs)
});
export { coinvestments_dealreview_teaser2 as "coInvestments_dealReview_teaser" }